export { default as StrategyProfileList } from './StrategyProfileList';
